/**
 * HUD-Teil: Aufgabenzeile und Minikarte.
 *
 * Die Minikarte zeigt nur **besuchte** Zellen (Ueberarbeitung B3). Der volle
 * Nebel in der Weltansicht kommt später; auf der Minikarte sitzt der Nutzen
 * und er ist hier billig zu haben.
 */

import type { Schnappschuss } from '@pg/protocol';
import { FELS } from '@pg/sim';
import { el, type HudTeil, type HudUmgebung } from './typen.js';

const FARBEN = {
  papier: '#EFE7D6',
  fels: '#221C16',
  tinte: '#191512',
  glut: '#D4471C',
  unbekannt: '#15120E',
};

export const kopf: HudTeil = {
  name: 'kopf',

  aktualisieren(u: HudUmgebung, s: Schnappschuss) {
    const aufgabe = el<HTMLDivElement>('#aufgabe');
    (aufgabe.querySelector('.ort') as HTMLElement).textContent =
      `${s.abstieg.region} · Tiefe ${s.abstieg.tiefe} · Grad ${s.abstieg.grad}`;
    (aufgabe.querySelector('.text') as HTMLElement).textContent = s.abstieg.aufgabe.text;

    const leinwand = el<HTMLCanvasElement>('#minikarte');
    const ctx = leinwand.getContext('2d');
    if (!ctx) return;
    const karte = u.karte();
    const besucht = u.besucht();
    const skala = leinwand.width / Math.max(karte.breite, karte.hoehe);

    ctx.fillStyle = FARBEN.unbekannt;
    ctx.fillRect(0, 0, leinwand.width, leinwand.height);

    for (let y = 0; y < karte.hoehe; y++) {
      for (let x = 0; x < karte.breite; x++) {
        const i = y * karte.breite + x;
        if (!besucht[i]) continue;
        ctx.fillStyle = karte.zellen[i] === FELS ? FARBEN.fels : FARBEN.papier;
        ctx.fillRect(x * skala, y * skala, skala + 0.6, skala + 0.6);
      }
    }

    // Der Förderkorb wird immer gezeigt, sobald er unten ist — er ist der
    // Rückweg und darf nicht gesucht werden müssen.
    if (s.abstieg.ausgang) {
      ctx.fillStyle = FARBEN.glut;
      ctx.beginPath();
      ctx.arc(s.abstieg.ausgang.x * skala, s.abstieg.ausgang.y * skala, 4, 0, Math.PI * 2);
      ctx.fill();
    }

    // Das Ziel wird erst gezeigt, wenn man dort war — sonst ist der Weg
    // dorthin keine Entdeckung mehr.
    const ziel = s.abstieg.ziel;
    if (ziel) {
      const zi = Math.floor(ziel.y) * karte.breite + Math.floor(ziel.x);
      if (besucht[zi]) {
        ctx.fillStyle = FARBEN.glut;
        ctx.beginPath();
        ctx.arc(ziel.x * skala, ziel.y * skala, 3, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    ctx.fillStyle = FARBEN.tinte;
    ctx.beginPath();
    ctx.arc(s.spieler.pos.x * skala, s.spieler.pos.y * skala, 2.8, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = FARBEN.papier;
    ctx.lineWidth = 1;
    ctx.stroke();
  },
};
